// Rappel de fin d'essai gratuit : une seule règle pour le cron qui l'envoie
// (pages/api/webhooks/trial-ending-reminder.js) et pour les calendriers qui
// l'annoncent (page des tarifs, onboarding).
//
// Le rappel part deux jours avant la fin de l'essai. Sur un essai court, il
// tombait le jour même de l'inscription et ne rappelait plus rien : en
// dessous de TRIAL_REMINDER_MIN_DAYS, il n'y en a donc pas. C'est l'e-mail de
// début d'essai qui donne alors la date et le montant du premier
// prélèvement, sa fréquence et le lien pour annuler (Visa n'impose pas de
// rappel sous 8 jours d'essai, mais exige ces informations à l'inscription).
//
// Mesuré dans Stripe le 19/09/2026 sur les essais de 7 jours : 13
// annulations sur 190 essais suivaient le rappel, 144 le précédaient.

export const TRIAL_REMINDER_MIN_DAYS = 5;
export const TRIAL_REMINDER_DAYS_BEFORE_END = 2;

/** Jour de l'essai où part le rappel, ou 0 quand l'essai n'en a pas. */
export function trialReminderDay(trialDays) {
    return trialDays >= TRIAL_REMINDER_MIN_DAYS
        ? trialDays - TRIAL_REMINDER_DAYS_BEFORE_END
        : 0;
}
